var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircleBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 8503.94 6803.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 4107.99,
    y1: 3682.54,
    x2: 4108.83,
    y2: 3680.03,
    gradientTransform: "translate(-4861506.78 3259645.46) scale(1184.07 -884.43)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90b2f7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 4114.13,
    y1: 3684.15,
    x2: 4113.45,
    y2: 3682.16,
    gradientTransform: "translate(-1845412.97 3352105.03) scale(450.33 -909.56)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c6d3ed"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M2865.95,5029.32c-306.5,261.28-696.23,404.52-1098.99,403.93-936.96,0-1696.53-759.4-1696.53-1696.16S830,2040.92,1766.97,2040.92c340.17-.55,672.58,101.64,953.71,293.17,145.22-714.49,730.72-1248.84,1430.91-1248.84,809.36,0,1465.48,714.04,1465.48,1594.89,0,732.29-453.46,1349.3-1071.47,1536.59,227.45,193.39,358.39,476.99,358.09,775.54,0,562.76-456.31,1018.96-1019.19,1018.96-550.48,0-999.04-436.32-1018.54-981.92Zm562.75-948.68c3.85-1.93,7.72-3.84,11.6-5.71-3.1-1.88-6.2-3.77-9.29-5.68-.77,3.84-1.52,7.56-2.31,11.39Z",
    fill: "url(#d)",
    isolation: "isolate",
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M5807.69,4404.63c0-664.47,538.77-1203.11,1203.36-1203.11,9.05,0,18.08,.1,27.09,.3,11.31-87.79,43.98-171.46,95.17-243.67-69.23,11.99-139.36,18-209.62,17.97-672.39,0-1217.46-544.96-1217.46-1217.2s545.07-1217.19,1217.46-1217.19,1217.45,544.95,1217.45,1217.19c.31,383.62-180.53,744.86-487.83,974.49,297.41,41.78,504.64,316.75,462.86,614.17-16.76,119.28-72.64,229.61-158.87,313.7,166.93,211.78,257.52,473.69,257.11,743.35,0,664.47-538.76,1203.1-1203.37,1203.1s-1203.36-538.66-1203.36-1203.1Z",
    fill: "url(#f)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleBg);
export default __webpack_public_path__ + "static/media/circle-bg.71666894fa6b7f40255068f16c082ba4.svg";
export { ForwardRef as ReactComponent };